<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="end">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">产品分类管理</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <router-link to="/admin/proCategory/add">
                            <a-button type="primary">
                                添加分类
                            </a-button>
                        </router-link>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :style="{padding: '10px 24px 24px 24px'}">
                <a-table
                    :columns="columns"
                    :row-key="record => record.proCategoryDO.uuid"
                    :data-source="data"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    bordered
                >

                    <template slot="action" slot-scope="text, record">
                        <a-popconfirm
                            v-if="data.length"
                            title="确定删除该分类?"
                            @confirm="() => deleteCategory(record.proCategoryDO.uuid)"
                            ok-text="删除"
                            cancel-text="取消"
                        >
                            <a-button size="small" type="danger">
                                删除
                            </a-button>
                        </a-popconfirm>
                    </template>

                    <a-row slot="expandedRowRender" slot-scope="record" style="margin: 0">
                        <a-col :span="6">
                            <span class="tb-content-title">网站域名:</span>{{ record.websiteDO.host }}
                        </a-col>
                    </a-row>
                    <!--编辑-->
                    <template slot="name" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record.proCategoryDO.uuid, 'title', $event)"/>
                    </template>
                </a-table>
            </a-col>
        </a-row>
    </div>
</template>

<script>

import EditableCell from "@/components/common/EditableCell";

export default {
    name: "ProCategory",
    data() {
        const columns = [
            {
                title: '名称',
                dataIndex: 'proCategoryDO.title',
                sorter: false,
                scopedSlots: {customRender: 'name'},
            },
            {
                title: '所属网站',
                dataIndex: 'websiteDO.title',
                sorter: false,
                filters:[]
            },
            {
                title: '所属域名',
                dataIndex: 'websiteDO.host',
                sorter: false,
                // width: '20%',
            },
            {
                title: '创建时间',
                dataIndex: 'proCategoryDO.createTime',
                sorter: true,
                // width: '20%',
            },
            {
                title: '操作',
                dataIndex: '',
                key: 'x',
                scopedSlots: {
                    customRender: 'action'
                }
            },
        ];
        return {
            data: [],
            pagination: {},
            loading: false,
            columns,
        };
    },
    components: {
        EditableCell,
    },
    methods:{
        handleTableChange(pagination, filters, sorter) {
            // console.log(filters)
            // console.log(JSON.stringify(filters))
            const pager = {...this.pagination};
            pager.current = pagination.current;
            this.pagination = pager;

            let params = {
                size: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
            };
            console.log(filters)
            if(filters['websiteDO.title']!==undefined){
                params['websiteFilter'] = filters['websiteDO.title'];
            }
            this.fetch(params);
        },
        fetch: function (params = {}) {
            this.loading = true
            let that = this
            this.$ajax.post(this.$host+"/admin/proCategory/list", {
                size: 10,
                ...params,
            }).then(function (res) {
                that.loading = false
                const result = res.data;
                if (result.code === 200) {
                    const pagination = {...that.pagination};
                    pagination.total = result.data.total;
                    that.data = result.data.list;
                    that.pagination = pagination;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        websiteList: function () {
            let that = this
            this.$ajax.get(this.$host+"/admin/website/listAll", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200 && result.data.length > 0) {
                    let d = [];
                    for(let i=0;i<result.data.length;i++){
                        d[i]={
                            text: result.data[i].title,
                            value: result.data[i].uuid
                        }
                    }
                    that.columns[1].filters = d;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        onCellChange(key, dataIndex, value) {
            const dataSource = [...this.data];
            const target = dataSource.find(item => item.proCategoryDO.uuid === key);
            if (target) {
                target[dataIndex] = value;
                let that = this;
                let params = {
                    uuid:key,
                    [dataIndex]:value,
                };
                this.updateData(params).then(function () {
                    that.data = dataSource;
                });
            }
        },
        updateData: function (params = {}) {
            let that = this;
            return new Promise((resolve, reject) => {
                this.$ajax.post(this.$host+"/admin/proCategory/edit", params)
                    .then(function (res) {
                        const result = res.data;
                        that.$message.info(result.msg);
                        if (result.code === 200) {
                            resolve(result.msg);
                        }else{
                            reject(result.msg);
                        }
                    }).catch(function (err) {
                    reject(err);
                });
            });
        },
        deleteCategory: function (category) {
            let params = new FormData();
            params.set("category",category);
            let that = this;
            this.$ajax.post(this.$host+"/admin/proCategory/delete", params)
                .then(function (res) {
                    const result = res.data;
                    that.$message.info(result.msg);
                    if(result.code===200){
                        that.fetch();
                    }
                }).catch(function (err) {
                    console.log(err)
            });
        }
    },
    mounted() {
        this.websiteList();
        this.fetch();
    }
}
</script>

<style scoped>

</style>